export const qrqsCode = 'fenice';

//global settings
export const brandName = 'Baba Bello';
export const PROD_ENV = true;
export const isDev = false;
export const enableErrorNotification = false;
export const withPosApi = true; //false for goodpay testtaste

export const filterEmptyCategoriesWithSections = true;

export const sseEnabled = false;
export const useExtrasExpander = true;
export const forceTableScan = true;
export const enableFlexCodes = false;
export const alwaysAskForTableNumberInhouse = false;
export const enableAllReady = false;
export const enableInhousePay = false;
export const enableInhouseOhnePay = false;
export const enableTakeawayPay = true;
export const enableTakeawayOhnePay = false;
export const enableDeliveryOhnePay = false;
export const enableDeliveryPay = true;

//Kiosk Config
export const kioskResetTimeoutAfterOrder = 5 * 1000;
export const kioskResetTimeoutOnInactivity = 50 * 1000;
export const enableKioskInhouseOhnePay = true;
export const enableKioskInhouseMitPay = true;
export const enableKioskInhousePayMitTip = false;
export const enableKioskTakeAwayOhnePay = true;
export const enableKioskTakeAwayMitPay = true;

export const enablePaypal = false;
export const enableGoodpay = true;
// export const displayPaymentMethods = ['PayPal', 'SEPA'];
export const displayPaymentMethods = ['Apple Pay', 'Google Pay', 'Girocard/Debitkarte', 'Kreditkarte'];
export const displayKioskPaymentMethods = ['Apple Pay', 'Google Pay', 'Girocard/Debitkarte', 'Kreditkarte'];
export const allowedPostalCodes = ['90491'];
export const enableGangSelection = false;
export const enableGang1 = true;
export const enableGang2 = true;
export const enableGang3 = true;
export const categoriesToExcludeFromGangSelection = [
  // 'Dessert',
];
export const hideCurrency = false;
export const tipConfig = {
  'none': 0,
  'a': 5,
  'b': 10,
  'c': 15,
}

export const enablePages = true;
export const enableOffers = false;
export const preloadCoupons = false;

export const stempelkarten = true;
export const spkType = 1;
//For type=1
export const spkPercentToCollect = 10; //Prozent
export const spkMaxCount = 10;
export const spkClearRest = true;

export const orderState$New = 'New';
export const orderState$Confirmed = 'Confirmed';
export const orderState$Rejected = 'Rejected';
export const orderState$Cancelled = 'Cancelled';
// export const orderState$PreparingFood = 'PreparingFood';8
// export const orderState$ReadyForCollection = 'ReadyForCollection';
// export const orderState$SentToKitchen = 'SentToKitchen';
// export const orderState$ReadyForDelivery = 'ReadyForDelivery';
export const orderState$Delivering = 'Delivering';
export const orderState$Collected = 'Collected';
export const orderState$Delivered = 'Delivered';
export const orderState$Served = 'Served';


export const usecase$tableOrdering = 'tableOrdering';
export const usecase$selfService = 'selfService';
export const usecase$inhouseMobilePayment = 'inhouseMobilePayment';
export const usecase$takeAway = 'takeAway';
export const usecase$digital = 'digital';
export const usecase$delivery = 'delivery';
export const usecase$taxi = 'taxi';
export const usecase$kellnerruf = 'kellnerruf';


export const notify$appLoaded = 'notifyAppLoaded';

export const action$LoadDocs = 'LoadDocs';
export const action$CountDocs = 'CountDocs';
export const action$DocUpserter = 'DocUpserter';
export const action$qsignal_LoadDocs = 'qsignal_LoadDocs';

// export const notify$tabSwitched = 'notifyTabSwitched';

export const notify$drinksUpdated = 'notifyDrinksUpdated';
export const notify$foodsUpdated = 'notifyFoodsUpdated';

export const type$foodOrder = 'foodOrder';
export const type$drinkOrder = 'drinkOrder';
export const type$generic = 'generic';

export const secretPassphrase = 'ULrgSB3ps2dykRKn';

export const action$PullFoodMenu = 'PullFoodMenu'; //inbound
export const action$PullDrinkMenu = 'PullDrinkMenu'; //inbound
export const action$GetNews = 'GetNews'; //inbound
export const action$LoadPages = 'LoadPages'; //inbound
export const action$GetLastModifiedValues = 'GetLastModifiedValues'; //inbound
export const action$SaveUserSettings = 'SaveUserSettings'; //inbound
export const action$SaveAppSettings = 'SaveAppSettings'; //inbound
export const action$UpsertAppUser = 'UpsertAppUser'; //inbound
export const action$LoadAppUser = 'LoadAppUser'; //inbound
export const action$CreateStripePaymentIntentCheckout = 'CreateStripePaymentIntentCheckout'; //inbound
export const action$CreatePayPalOrderCheckout = 'CreatePayPalOrderCheckout'; //inbound
export const action$DeleteGpPaymentMethod = 'DeleteGpPaymentMethod';
export const action$SaveNewOrder = 'SaveNewOrder';
export const action$Kellnerruf = 'Kellnerruf'; //inbound
export const action$GetLastSelfOrders = 'GetLastSelfOrders';
// export const action$GetTakeAwayData = 'GetTakeAwayData';
export const action$LoadOffers = 'LoadOffers';
export const action$LoadCartItems = 'LoadCartItems';
export const action$LoadCoupons = 'LoadCoupons';
// export const action$LoadReferralprograms = 'LoadReferralprograms';
export const action$AcceptInvitation = 'AcceptInvitation';
export const action$SaveCartItems = 'SaveCartItems';
export const action$MakeFriends = 'MakeFriends';
export const action$GetAppconfig = 'GetAppconfig';
export const action$ConfirmAllReady = 'ConfirmAllReady';
export const action$GetSecToken = 'GetSecToken';
export const action$LoadStores = 'LoadStores';
// export const action$SubscribePushTopics = 'SubscribePushTopics';
export const action$LoadStempelkarte = 'LoadStempelkarte';
export const action$GetDeliveryAreaInfo = 'GetDeliveryAreaInfo';

//GoodpayFrontendApi
export const action$GoodpayFrontendApi = 'GoodpayFrontendApi';


export const action$CreatePayPalOrder = 'CreatePayPalOrder';

// export const frontentToken = 'QHTnt0xiuvYEbnAk';

// export const action$GetLiefergebiete = 'GetLiefergebiete';

export function getDisplayPaymentMethods(asSentence) {
  let l = displayPaymentMethods.join(', ');
  if (asSentence) {
    return 'Die akzeptierten Zahlungsmethoden sind ' + l + '.';
  }
  return l;
}

export function getDisplayKioskPaymentMethods(asSentence) {
  let l = displayKioskPaymentMethods.join(', ');
  if (asSentence) {
    return 'Die akzeptierten Zahlungsmethoden sind ' + l + '.';
  }
  return l;
}

//*********************
//External Services
//*********************


